import { clock } from '@/shared/lib/clock/clock';
import { createApi, endpoint } from '@/shared/lib/http/endpoint';

// /time — server clock readback, used to seed the request-ticket signing
// clock.  Single-endpoint surface so it stays self-contained inside the
// clock lib (no need for a separate api file).
type TimeResponse = { timestamp: number };
const clockApi = createApi({
  '/time': endpoint<void, TimeResponse>('POST'),
});

// POST /time and hand the server seconds-timestamp to the clock service.
// Failures fall through silently; request tickets fall back to the local clock
// and the backend rejects only if the user's clock is actually badly skewed.
export async function syncServerTime(): Promise<void> {
  try {
    const res = await clockApi['/time'](undefined, { timeout: 3000, ignoreErrorMsg: true });
    clock.syncOffset(res.timestamp);
  } catch {
    /* boot must not block on /time; treat as zero offset */
  }
}
